<template>
  <div class="">
    <Liste v-if="$route.path.split('/').length<=2"/>
    <router-view v-else></router-view>
  </div>
</template>

<script>
  import Liste from '@/components/Liste'
  export default {
    components: {
      Liste,
    },
  };
</script>